import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TypeSortie } from 'app/models/type-sortie';
import { Patients } from 'app/models';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'app/utils/notifications.service';
import { SortieDialyseService } from 'app/core/sortie-dialyse.service';
import { TypeSortieService } from 'app/core/type-sortie.service';
import { NgbDateFRParserFormatter } from 'app/ngb-date-fr-parser-formatter';
import {  SortieDialyse } from 'app/models/sortie-dialyse';
import { PatientService } from 'app/core/patient.service';

@Component({
  selector: 'app-pickersortie-dialyse',
  templateUrl: './pickersortie-dialyse.component.html',
  styleUrls: ['./pickersortie-dialyse.component.css']
})
export class PickersortieDialyseComponent implements OnInit {
  typeSorties: TypeSortie[];
  form: FormGroup;
  public minDate = { year: 1800, month: 1, day: 1 };
  public maxDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    day: new Date().getDate()
  };
  public createAutre: boolean;
  @Input()
  patient: Patients; // pour editer un patient
  @Input()
  titre: string; // le titre du modal ; du formulaire

  constructor(
    private activeModalPatient: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private notification: NotificationsService,
    private service: SortieDialyseService,
    private typeSortieService : TypeSortieService,
    private patientService : PatientService,
    private dateFormater: NgbDateFRParserFormatter
  ) {}
  ngOnInit() {
    this.typeSortieService.find().subscribe(type => {
      console.log(type);
      this.typeSorties = type;
    });
    this.initForm();
    console.log(this.patient);

  }

  public initForm() {


    if(this.patient.sortieDialyse){
      console.log("1111111111111111111111111111111111111&sortie");
      this.form = this.formBuilder.group({
        dateSortie: [this.dateFormater.parse(this.patient.sortieDialyse.dateSortie), Validators.required],
        typeSortie: [this.patient.sortieDialyse.typeSortie, Validators.required],
        description: [this.patient.sortieDialyse.description]
      });
    }else{
      this.form = this.formBuilder.group({
        dateSortie: [null, Validators.required],
        typeSortie: [null, Validators.required],
        description: [null]
      });
    }


  }

  submitForm() {
    const value= this.form.value;
    console.log(value);
    let sortieDialyse = new SortieDialyse();
    sortieDialyse.dateSortie= this.dateFormater.format(value.dateSortie);
    sortieDialyse.description= value.description;
    sortieDialyse.typeSortie= value.typeSortie;
    if(this.patient.sortieDialyse){
      sortieDialyse.id = this.patient.sortieDialyse.id;
    }

    console.log("1111111111111111111111111111111111111&sortie",sortieDialyse);
this.service.create(sortieDialyse).subscribe(data => {
  this.notification.addToast("Patient Sortie de la liste", "infos", "success");
  this.patient.lot = null;
  this.patient.sortieDialyse =  data;
  this.patient = this.patientService.formatDate(this.patient);

  if(this.patient.contacts){
    let patient= new Patients();
      patient.id=this.patient.id;
    this.patient.contacts.forEach(element => {

      element.patient = patient;
    });
  }

  console.log("update patient", this.patient);

  this.patientService.updatewithout(this.patient).subscribe( data =>{
    console.log("update patient");
  });

},(erreur)=>{
  this.notification.addToast("Erreur d'execution de la requête", "Alerte", "error");
  console.error(erreur);

});

this.activeModalPatient.dismiss(true);
  }
  dismiss(){
    this.activeModalPatient.dismiss();
  }



  public compare(p1: any, p2: any) {
    return p1 && p2 ? p1.id === p2.id : p1 === p2;
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/patients/pickersortie-dialyse/pickersortie-dialyse.component.ts